import { Option } from '@okapi/types';

import { School } from '../../types';

export const getOptions = (schools: Pick<School, 'id' | 'name'>[]): Option[] =>
  schools.map(({ id, name }) => ({
    value: id,
    label: name
  }));
